<mat-card class="login-card" appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-title">
      <mat-icon svgIcon="ti-logo-final" class="login-icon"></mat-icon>
      <p class="sign-up">{{ title() }}</p>
      <hr class="content-hr" />
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="content" [ngClass]="keybackup() ? 'keybackup' : ''">
    <ng-content class="input-component" select=".body"></ng-content>
  </mat-card-content>
  <hr class="content-hr hr-footer" />
  <mat-card-footer class="footer">
    <ng-content class="input-component" select=".footer-content"></ng-content>
    <p class="homeserver clamp-text">Homeserver: {{ this.config.get('homeserverHostname') }}</p>
    <p class="trademark">© BITMARCK Holding GmbH</p>
  </mat-card-footer>
  @if (showSpinner()) {
    <div [attr.data-testid]="testIds.spinnerBackdrop" class="spinner-backdrop">
      <app-sb-spinner class="verify-spinner" [type]="'spinnerIndeterminate'"></app-sb-spinner>
    </div>
  }
</mat-card>
